const GTM_ID = "GTM-KXZRG4LK";

function scheduleGtmLoad() {
	if (typeof window.requestIdleCallback === "function") {
		window.requestIdleCallback(() => loadGTM(), { timeout: 5000 });
	} else {
		window.setTimeout(loadGTM, 3000);
	}
}

/** Load GTM container once (after consent or prior acceptance). */
export function loadGTM() {
	if (typeof window === "undefined") return;
	if (window.__gtmLoaded) return;
	window.__gtmLoaded = true;

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

	const script = document.createElement("script");
	script.async = true;
	script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
	document.head.appendChild(script);
}

export function initConsentDefaults() {
	if (typeof window === "undefined") return;
	window.dataLayer = window.dataLayer || [];
	window.gtag =
		window.gtag ||
		function gtag() {
			window.dataLayer.push(arguments);
		};
	window.gtag("consent", "default", {
		ad_storage: "denied",
		analytics_storage: "denied",
		ad_user_data: "denied",
		ad_personalization: "denied",
	});
	window.gtag("set", "url_passthrough", true);
	window.gtag("set", "ads_data_redaction", true);
}

export { scheduleGtmLoad };
